"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Geometry = _interopRequireDefault(require("../geom/Geometry"));

var _Coordinate = _interopRequireDefault(require("../geom/Coordinate"));

var _Polygon = _interopRequireDefault(require("../geom/Polygon"));

var _Double = _interopRequireDefault(require("../../../../java/lang/Double"));

var _GeometryCollection = _interopRequireDefault(require("../geom/GeometryCollection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var InteriorPointArea =
/*#__PURE__*/
function () {
  function InteriorPointArea() {
    _classCallCheck(this, InteriorPointArea);

    InteriorPointArea.constructor_.apply(this, arguments);
  }

  _createClass(InteriorPointArea, [{
    key: "addPolygon",
    value: function addPolygon(geometry) {
      if (geometry.isEmpty()) return null;
      var intPt = null;
      var width = null;
      var bisector = this.horizontalBisector(geometry);

      if (bisector.getLength() === 0.0) {
        width = 0;
        intPt = bisector.getCoordinate();
      } else {
        var intersections = bisector.intersection(geometry);
        var widestIntersection = this.widestGeometry(intersections);
        width = widestIntersection.getEnvelopeInternal().getWidth();
        intPt = InteriorPointArea.centre(widestIntersection.getEnvelopeInternal());
      }

      if (this._interiorPoint === null || width > this._maxWidth) {
        this._interiorPoint = intPt;
        this._maxWidth = width;
      }
    }
  }, {
    key: "getInteriorPoint",
    value: function getInteriorPoint() {
      return this._interiorPoint;
    }
  }, {
    key: "widestGeometry",
    value: function widestGeometry() {
      if (arguments[0] instanceof _GeometryCollection.default) {
        var gc = arguments[0];

        if (gc.isEmpty()) {
          return gc;
        }

        var widestGeometry = gc.getGeometryN(0);

        for (var i = 1; i < gc.getNumGeometries(); i++) {
          if (gc.getGeometryN(i).getEnvelopeInternal().getWidth() > widestGeometry.getEnvelopeInternal().getWidth()) {
            widestGeometry = gc.getGeometryN(i);
          }
        }

        return widestGeometry;
      } else if (arguments[0] instanceof _Geometry.default) {
        var geometry = arguments[0];

        if (!(geometry instanceof _GeometryCollection.default)) {
          return geometry;
        }

        return this.widestGeometry(geometry);
      }
    }
  }, {
    key: "horizontalBisector",
    value: function horizontalBisector(geometry) {
      var envelope = geometry.getEnvelopeInternal();
      var bisectY = SafeBisectorFinder.getBisectorY(geometry);
      return this._factory.createLineString([new _Coordinate.default(envelope.getMinX(), bisectY), new _Coordinate.default(envelope.getMaxX(), bisectY)]);
    }
  }, {
    key: "add",
    value: function add(geom) {
      if (geom instanceof _Polygon.default) {
        this.addPolygon(geom);
      } else if (geom instanceof _GeometryCollection.default) {
        var gc = geom;

        for (var i = 0; i < gc.getNumGeometries(); i++) {
          this.add(gc.getGeometryN(i));
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return InteriorPointArea;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "centre",
    value: function centre(envelope) {
      return new _Coordinate.default(InteriorPointArea.avg(envelope.getMinX(), envelope.getMaxX()), InteriorPointArea.avg(envelope.getMinY(), envelope.getMaxY()));
    }
  }, {
    key: "avg",
    value: function avg(a, b) {
      return (a + b) / 2.0;
    }
  }]);

  return InteriorPointArea;
}();

exports.default = InteriorPointArea;

var SafeBisectorFinder =
/*#__PURE__*/
function () {
  function SafeBisectorFinder() {
    _classCallCheck(this, SafeBisectorFinder);

    SafeBisectorFinder.constructor_.apply(this, arguments);
  }

  _createClass(SafeBisectorFinder, [{
    key: "updateInterval",
    value: function updateInterval(y) {
      if (y <= this._centreY) {
        if (y > this._loY) this._loY = y;
      } else if (y > this._centreY) {
        if (y < this._hiY) {
          this._hiY = y;
        }
      }
    }
  }, {
    key: "getBisectorY",
    value: function getBisectorY() {
      this.process(this._poly.getExteriorRing());

      for (var i = 0; i < this._poly.getNumInteriorRing(); i++) {
        this.process(this._poly.getInteriorRingN(i));
      }

      var bisectY = InteriorPointArea.avg(this._hiY, this._loY);
      return bisectY;
    }
  }, {
    key: "process",
    value: function process(line) {
      var seq = line.getCoordinateSequence();

      for (var i = 0; i < seq.size(); i++) {
        var y = seq.getY(i);
        this.updateInterval(y);
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return SafeBisectorFinder;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "getBisectorY",
    value: function getBisectorY(poly) {
      var finder = new SafeBisectorFinder(poly);
      return finder.getBisectorY();
    }
  }]);

  return SafeBisectorFinder;
}();

SafeBisectorFinder.constructor_ = function () {
  this._poly = null;
  this._centreY = null;
  this._hiY = _Double.default.MAX_VALUE;
  this._loY = -_Double.default.MAX_VALUE;
  var poly = arguments[0];
  this._poly = poly;
  this._hiY = poly.getEnvelopeInternal().getMaxY();
  this._loY = poly.getEnvelopeInternal().getMinY();
  this._centreY = InteriorPointArea.avg(this._loY, this._hiY);
};

InteriorPointArea.SafeBisectorFinder = SafeBisectorFinder;

InteriorPointArea.constructor_ = function () {
  this._factory = null;
  this._interiorPoint = null;
  this._maxWidth = 0.0;
  var g = arguments[0];
  this._factory = g.getFactory();
  this.add(g);
};